import { BaseExtension } from '../extensions';
export class BaseTransport extends BaseExtension {
    isBatched() {
        return false;
    }
    getIgnoreUrls() {
        return [];
    }
}
